import React, { useState } from "react";
import ApiDatabase from "server";
import UseContext from "hooks/useContext";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import PerimeterModalFooter from "components/modal/dataModal/data/perimeter/PerimeterModalFooter";
import usePerimeterModal from "components/modal/dataModal/data/perimeter/usePerimeterModal";
import { ARCHIVE_ERROR_OVERRIDES } from "pages/profil/perimeters/perimeterErrors";
import { fillText, getCountText } from "pages/profil/perimeters/perimeterText";

// Only finished missions are left on the perimeter, and no member: nothing to
// transfer, the archive is a plain confirmation.
const ArchivePerimeterModal = () => {
    const { language, perimeterModalData } = UseContext();
    const { isSaving, setIsSaving, close, succeed, fail } = usePerimeterModal();
    const [{ perimeter, usage }] = useState(() => perimeterModalData || {});
    const finishedMissions = Number(usage?.finishedMissions) || 0;

    // Without any finished mission there is no history to mention.
    const description = [
        finishedMissions > 0
            ? getCountText(
                  language,
                  "perimeters.archive.finishedMissions",
                  finishedMissions
              )
            : "",
        language.getValue("perimeters.archive.notProposed"),
    ]
        .filter(Boolean)
        .join(" ");

    const handleConfirm = () => {
        if (isSaving) return;
        setIsSaving(true);
        ApiDatabase.postArchivePerimeter(
            { id: perimeter?.id, transferTo: null },
            () => succeed(language.getValue("perimeters.toast.archived")),
            (err) => fail(err, { overrides: ARCHIVE_ERROR_OVERRIDES })
        );
    };

    return (
        <>
            <Modalheader hide={close} hideShow={true}>
                {fillText(language.getValue("perimeters.archive.title"), {
                    name: perimeter?.name,
                })}
            </Modalheader>
            <ModalBody>
                <p className="text-sm text-gray-600">{description}</p>
            </ModalBody>
            <PerimeterModalFooter
                confirmLabel={language.getValue("perimeters.archive.confirm")}
                savingLabel={language.getValue("perimeters.archive.archiving")}
                isSaving={isSaving}
                onCancel={close}
                onConfirm={handleConfirm}
            />
        </>
    );
};

export default ArchivePerimeterModal;
